import { Box, Card, CardContent, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { useSessionContext } from "../contexts/SessionContext";

export default function NetworkError({ error }: { error: string }) {
  const { t } = useTranslation();
  const { initialized, organization, user } = useSessionContext();

  return (
    <Container sx={{ marginTop: 5 }}>
      <Stack sx={{ p: 2 }} direction="row">
        <WifiOffIcon sx={{ fontSize: 60 }} />

        <Box ml={5}>
          <Typography variant="h1" gutterBottom>
            {error}
          </Typography>

          <Typography variant="body2" fontSize={18} mb={3}>
            {t("network-error.text")}
          </Typography>

          <Card variant="outlined" style={{ padding: 10 }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                {t("network-error.debug-infos")}
              </Typography>
              <Typography>Init: {initialized ? "ok" : "nok"}</Typography>
              <Typography>Org: {organization?.organization?.id ?? "<null>"}</Typography>
              <Typography>
                Account: {user?.id ?? "<no.id>"} {user?.email}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Stack>
    </Container>
  );
}
